import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GET_LOCATION_STATUSES, LocationStatus } from './location-status.graphql';

@Injectable({
  providedIn: 'root',
})
export class LocationStatusApiService {
  constructor(private apollo: Apollo) {}

  getAll(): Observable<LocationStatus[]> {
    return this.apollo.use('API_GATEWAY')
      .query<{ locationStatuses: LocationStatus[] }>({
        query: GET_LOCATION_STATUSES,
        fetchPolicy: 'no-cache',
      })
      .pipe(map((result) => result.data.locationStatuses));
  }
}